// @flow

import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';
import FreeModal from 'components/FreeModal/FreeModal';

type Props = {
  forHeader: boolean,
}

const PloSwitch = ({
  forHeader = true,
}: Props) => {
  const [isPlo5, setPlo5] = useState<boolean>(sessionStorage.getItem('isPlo5') === 'true');
  // const isFreeUser = useSelector((state) => state.profile.free_access);
  const isFreeUser = localStorage.getItem('freeAccess') === 'true';
  const [freeModalVisible, setFreeModalVisible] = useState<boolean>(false);

  useEffect(() => {
    if (isFreeUser) {
      setPlo5(false);
    }
  }, []);

  useEffect(() => {
    const syncSelection = () => {
      setPlo5(!isFreeUser && sessionStorage.getItem('isPlo5') === 'true');
    };
    window.addEventListener('storage', syncSelection);
    return () => window.removeEventListener('storage', syncSelection);
  }, [isFreeUser]);

  useEffect(() => {
    sessionStorage.setItem('isPlo5', isPlo5);
    window.dispatchEvent(new Event('storage'));
    const url = new URL(window.location);
    url.searchParams.set('isPlo5', isPlo5);
    window.history.pushState(null, '', url.toString());
  }, [isPlo5]);

  return (
    // eslint-disable-next-line no-nested-ternary
    <div
      className={cn(styles.switchWrapper, {
        [styles.boxPlo5]: forHeader && isPlo5,
        [styles.boxPlo4]: forHeader && !isPlo5,
        [styles.menuSwitch]: !forHeader,
      })}
      role="group"
      aria-label="Game type"
    >
      <button
        type="button"
        aria-pressed={!isPlo5}
        className={cn(styles.switchCell, { [styles.active]: !isPlo5 })}
        onClick={() => setPlo5(false)}
      >
        PLO 4
      </button>
      <button
        type="button"
        aria-pressed={isPlo5}
        aria-disabled={isFreeUser}
        className={
          cn(styles.switchCell,
            { [styles.active]: isPlo5 },
            `${isFreeUser ? styles.disabled : ''}`)
        }
        onClick={() => (isFreeUser ? null : setPlo5(true))}
        onMouseOver={() => (isFreeUser ? setFreeModalVisible(true) : null)}
        onFocus={() => (isFreeUser ? setFreeModalVisible(true) : null)}
        onMouseOut={() => (isFreeUser ? setFreeModalVisible(false) : null)}
        onBlur={() => (isFreeUser ? setFreeModalVisible(false) : null)}
      >
        PLO 5
        {(isFreeUser && forHeader) && <FreeModal visible={freeModalVisible} />}
      </button>
    </div>
  );
};

export default PloSwitch;
